export default __webpack_public_path__ + "static/media/ed_6.cf396b19.mp3";